export default
  {
    "header": {
      "title": "Löytösampo",
      "login": "Kirjaudu sisään",
      "logout": "Kirjaudu ulos",
      "notification": {
        "logoutSuccess": "Olet kirjautunut sisään"
      }
    },
    "": "",
    "loginPage": {
      "title": "Kirjaudu sisään",
      "email": "Sähköposti",
      "password": "Salasana",
      "login": "Kirjaudu",
      "signup": "Rekisteröidy",
      "forgotPassword": "Unohtuiko salasanasi?",
      "loginWith": "Kirjaudu toisella palvelulla",
      "googleLogin": "Kirjaudu Google-tilillä",
      "notAMemberYet": "Ei vielä käyttäjätunnusta?",
      "error": {
        "emptyField": "Sähköposti ja salasana puuttuvat!"
      }
    },
    "signupPage": {
      "title": "Rekisteröidy",
      "username": "Käyttäjätunnus",
      "email": "Sähköposti",
      "password": "Salasana",
      "signup": "Rekisteröidy",
      "alreadyAMember": "Oletko jo rekisteröitynyt?",
      "login": "Kirjaudu sisään",
      "registrationDone": "Rekisteröityminen onnistui!"
    },
    "nearByPage": {
      "map": {
        "mapLayers": {
          "backGroundMap": "Taustakartta",
          "topographicalMap": "Maastokartta",
          "googleMaps": "Google Maps"
        },
        "overLays": {
          "arkeologiset_loydot": "Arkeologiset löydöt",
          "arkeologiset_kohteet_alue": "Muinaisjäännösten ja muiden kulttuuriperintökohteiden aluerajaukset",
          "arkeologiset_kohteet_piste": "Muinaisjäännökset ja muut kulttuuriperintökohteet",
          "maailmanperinto_alue": "Maailmanperintökohteet, alueet",
          "maailmanperinto_piste": "Maailmanperintökohteet, pisteet",
          "rakennusperinto_alue": "Suojellut rakennukset, aluerajaukset (Rakennusperintörekisteri)",
          "rakennusperinto_piste": "Suojellut rakennukset (Rakennusperintörekisteri)",
          "arkeologisten_kohteiden_alakohteet_piste": "Arkeologisten kohteiden alakohteet",
          "rky_alue": "Valtakunnallisesti merkittävät rakennetut ympäristöt, aluerajaukset",
          "rky_piste": "Valtakunnallisesti merkittävät rakennetut ympäristöt, pistemäiset kohteet",
          "rky_viiva": "Valtakunnallisesti merkittävät rakennetut ympäristöt, tiet ja muut kohteet viivamaiset kohteet"
        },
        "alert": {
          "zoomAlertTitle": "Zoomaa lähemmäs",
          "zoomAlertContent": "Näet valitun tason, kun zoomauksen rajaus on 13 tai sitä suurempi.",
          "zoomAlertConfirmation": "Ok",
          "gettingLocationFailed": "Sijaintiasi ei voitu tarkentaa. Varmista, että GPS on päällä."
        },
        "mapContent": {
          "name": "Nimi",
          "town": "Kaupunki",
          "link": "Linkki",
          "more": "Lisää"
        }
      },
      "tabs": {
        "map": "Kartta",
        "heatmap": "Lämpökartta",
        "statistics": "Tilastot",
        "table": "Taulukko"
      },
      "statistics": {
        "chart": {
          "selectProperty": "Valitse ominaisuus",
          "material": "Materiaali",
          "type": "Esinekategoria",
          "period": "Ajoitus"
        }
      },
      "table": {
        "title": "Esineen luokitus",
        "material": "Materiaali",
        "type": "Esinetyyppi",
        "period": "Ajoitus",
        "municipality": "Kunta",
        "province": "Maakunta",
        "specification": "Löytötapa",
        "previewImage": "Kuvan esikatselu",
        "notProvidedValue": "Ei saatavilla",
        "noAdditionalInformation": "Lisätietoja ei saatavilla!",
        "more": "Lisää"
      }
    },
    "myFindsPage": {
      "header": {
        "title": "Omat löydöt",
        "show": "",
        "orderSelect": {
          "orderBy": "",
          "date": "",
          "municipality": "",
          "totalFinds": ""
        }
      },
      "more": "Katso tietoja",
      "share": "Jaa",
      "continue": "Lisää tietoja",
      "status": "Tila",
      "noFindsInfo": "Valitsemasi löytöilmoitus ei sisällä löytöjä.",
      "noFindsError": "Ei löytöjä!",
      "container": {
        "report": "Löytöilmoitus",
        "municipality": "Kunta",
        "time": "{d, date, short}",
        "timeClock": "Kellonaika",
        "finds": "Löytöjen määrä: (numero)"
      },
      "statuses": {
        "draft": "Luonnos",
        "await_review": "Odottaa käsittelyä",
        "in_review": "Käsittelyssä",
        "validated": "Käsitelty",
        "rejected": "Palautettu",
        "peding_user": "Odottaa lisätietoja"
      }
    },
    "notFoundPage": {
      "pageNotFound": "Hups! Sivustoon ei saada yhteyttä.",
      "goToHomePage": "Siirry etusivulle"
    },
    "legalityCheckerPage": {
      "alert": {
        "allowed": {
          "header": "Saat etsiä täällä!",
          "description": "Paikalla ei ole arkeologisia kohteita."
        },
        "forbidden": {
          "header": "Maata ei saa kaivaa tällä alueella!",
          "description": "Maata ei saa kaivaa muinaismuistolailla (295/1963) rauhoitetulla kiinteällä muinaisjäännöksellä, sellaiseksi arvellulla tai luonnonsuojelulailla suojellulla alueella ilman erikseen haettua lupaa. Rauhoitetun muinaisjäännöksen lähettyvillä, alle 200 metrin etäisyydellä kohteesta kaivamista ei suositella."
        }
      }
    },
    "overview": {
      "title": "Yhteenveto",
      "notProvidedValue": "Ei tietoja",
      "findSite": {
        "title": "Löytöpaikan tiedot",
        "photos": "Löytöpaikan kuvat",
        "location": "Sijainti",
        "additionalMaterials": "Lisätiedot"
      },
      "find": {
        "title": "Löytöesineen tiedot",
        "subTitle": "Löytöesine",
        "photos": "Kuvat",
        "depth": "Löytösyvyys",
        "type": "Esineen nimi",
        "timing": "Ajoitus",
        "material": "Materiaali"
      }
    },
    "report": {
      "stepOne": "Ohjeet",
      "stepTwo": "Tiedot",
      "stepThree": "Lisätiedot",
      "stepFour": "Valmis!",
      "skip": "Ohita",
      "optionalSection": "",
      "reportSent": "Ilmoituksesi on nyt lähetetty!",
      "back": "Takaisin",
      "notifications": {
        "photoDeletionError": ""
      },
      "questionZero": {
        "question": "Haluatko tutusta ohjeisiin ennen löytöilmoituksen tekemistä?",
        "help": "Kysymykset auttavat sinua eteenpäin. Valitse vaihtoehdoista sopivin.",
        "buttonOne": "Kyllä",
        "buttonTwo": "Ei"
      },
      "questionProvideHelp": {
        "question": "Hienoa, ohessa sinulle parhaiten sopivat ohjeet.",
        "help": "Valitse yksi ohjeista.",
        "buttonOne": "Jatka",
        "options": {
          "optionOne": "Yleiset ohjeet",
          "optionTwo": "Aloituspaketti",
          "optionThree": "Löytöilmoitusohje"
        }
      },
      "questionFindTimeDetermining": {
        "question": "Ilmoitatko juuri löytämäsi esineen?",
        "help": "Seuraavien kysymysten avulla voit tallentaa löytöpaikan ja -ajan automaattisesti.",
        "buttonOne": "Kyllä, olen löytöpaikalla.",
        "buttonTwo": "Ei, olen löytänyt sen aikaisemmin."
      },
      "questionFindLocation": {
        "question": "Valitse löytöpaikka kartalta.",
        "help": "Merkitse kartalle tarkkaan, mistä olet tehnyt löydön.",
        "buttonOne": "Valmis, siirry eteenpäin."
      },
      "questionFindPhotos": {
        "question": "Lisää kuvia löydöstäsi.",
        "help": "Lisää vähintään yksi kuva.",
        "buttonOne": "Jatka"
      },
      "questionFindSitePhotos": {
        "question": "Lisää kuvia löytöpaikasta.",
        "help": "Lisää vähintään yksi kuva.",
        "buttonOne": "Jatka"
      },
      "questionFindDate": {
        "question": "Valitse tai arvioi löytöaika.",
        "help": "Valitse löytöajaksi tarkka päivämäärä.",
        "buttonOne": "Jatka",
        "selectionText": "Tiedän tarkan päivämäärän."
      },
      "questionFindDepth": {
        "question": "Syötä löytösyvyys.",
        "help": "Lisätietoja löytösyvyydestä",
        "label": "Löytösyvyys",
        "depth": "Syvyys",
        "buttonOne": "Jatka",
        "useSlider": "",
        "depthUnit": "cm"
      },
      "questionFindMaterial": {
        "question": "Valitse löydön materiaali.",
        "help": "Jos et löydä sopivaa materiaalia, valitse kohta 'muut'.",
        "buttonOne": "Jatka",
        "label": "",
        "placeholder": ""
      },
      "questionFindType": {
        "question": "Valitse esineen nimi.",
        "help": "Jos et löydä sopivaa esineen nimeä, valitse kohta 'muut'.",
        "buttonOne": "Jatka",
        "label": "",
        "placeholder": ""
      },
      "questionFindTime": {
        "question": "Arvioi löytösi ajoitus.",
        "help": "Jos et löydä sopivaa ajoitusta, valitse kohta 'muut'.",
        "buttonOne": "Jatka",
        "label": "",
        "placeholder": ""
      },
      "questionAdditionalMaterials": {
        "question": "Onko sinulla muita havaintoja löytöpaikalta?",
        "help": "Kuvaile havaintojasi.",
        "buttonOne": "Jatka"
      },
      "questionAddAnotherFind": {
        "question": "Onko sinulla muita löytöjä samalta löytöpaikalta?",
        "help": "Ilmoitus voi sisältää useita löytöjä samalta löytöpaikalta. Katso ilmoitusohjeet.",
        "buttonOne": "Kyllä",
        "buttonTwo": "Ei"
      },
      "questionOverview": {
        "buttonOne": "Hyvältä näyttää, lähetä!"
      },
      "questionReportSent": {
        "question": "Ilmoituksesi on lähetetty!",
        "help": "Ilmoituksesi on lähetetty. Saat siitä pian ilmoituksen."
      },
      "questionAddMoreInformation": {
        "question": "Haluatko lisätä tietoja ilmoitukseen?",
        "help": "Jos hyväksyt tämän, voit lisätä tietoja ilmoitukseesi.",
        "buttonOne": "Kyllä",
        "buttonTwo": "Ei"
      }
    },
    "findMaterials": {
      "stone": "Kivi",
      "slag": "Kuona",
      "glass": "Lasi",
      "metal": "Metalli",
      "leather": "Nahka",
      "wood": "Puu",
      "iron": "Rauta",
      "bronze": "Pronssi",
      "porcelain": "Keramiikka"
    },
    "bottomNavBar": {
      "home": "Etusivu",
      "mine": "Omat löydöt",
      "nearby": "Lähellä",
      "report": "Ilmoita",
      "more": "Opas"
    },
    "helpBar": {
      "saveAs": "Tallenna luonnoksena",
      "delete": "Poista",
      "notifications": {
        "noDataAvailable": "",
        "reportDeleted": "Ilmoituksesi on poistettu onnistuneesti!",
        "reportSent": "Ilmoituksesi luonnos on tallennettu onnistuneesti!"
      },
      "dialog": {
        "header": "Ohjeet",
        "closeBtn": "Sulje"
      }
    },
    "photoRenderer": {
      "infoText": "",
      "errorHeader": "Kuva liian suuri!",
      "errorText": "Kuvatiedoston koko on liian suuri. Tallennettavan kuvatiedoston maksimikoko on 30 Mt. Yritä uudelleen!",
      "confirmationBtn": "Ok",
      "dialog": {
        "title": "Lisää kuva",
        "takePhoto": "Ota kuva",
        "selectFromGallery": "Valitse tiedostosta",
        "cancel": "Peruuta"
      }
    },
    "morePage": {
      "headers": {
        "usefulTools": "Aineistot ja oppaat",
        "tutorials": "Oppaat",
        "recommendedApps": "Suositellut sovellukset"
      },
      "checkLegality": "Etsi lähellä olevat arkeologiset kulttuuriperintökohteet. Muinaisjäännöksellä ja sen suoja-alueella ei saa kaivaa maata ilman lain nojalla annettua lupaa.",
      "fhaHowToReport": "Löydöstä ilmoittaminen",
      "fhaCulturalHeritageMaterial": "Arkeologisen kulttuuriperinnön suojelu",
      "photoFrame": "Löytöjen kuvausalusta"
    },
    "facetDrawer": {
      "facetedSearch": "Suodatettu haku",
      "searchResults": "Hakutulokset",
      "searchCriteria": "Hakukriteerit",
      "emptyBtn": "Tyhjä",
      "facetCriteria": {
        "type": "Esineen nimi",
        "material": "Materiaali",
        "period": "Ajoitus",
        "municipality": "Kunta",
        "province": "Maakunta"
      }
    },
    "langMenu": {
      "abbreviation": {
        "english": "EN",
        "finnish": "FI",
        "swedish": "SV"
      }
    },
    "smartHelper": {
      "table": "Taulukko",
      "map": "Kartta",
      "nearbySpecific": "Lähialueen löydöt",
      "overall": "Kaikki löydöt"
    },
    "appHomePage": {
      "contentContainer": {
        "recentFinds": "Viimeaikaiset löydöt",
        "guides": "Oppaat ja ohjeet",
        "applicationTagline": "Vastaanotettujen löytöilmoitusten määrä Löytösammossa: x",
        "headerTitle": "Suomen arkeologisten löytöjen tieto- ja ilmoitusportaali",
        "learnMore": "Opi lisää",
        "name": "Löytösampo"
      }
    },
    "answerOptions": {
      "date": "Päivämäärä",
      "approximateDate": "Arvioitu päivämäärä",
      "additionalMaterials": "Lisätiedot",
      "btnEnterManually": "",
      "dialog": {
        "title": "",
        "content": "",
        "latitude": "",
        "longitude": "",
        "cancel": "",
        "insert": ""
      }
    },
    "autocompleter": {
      "noOptions": "",
      "loading": "",
      "save": ""
    }
  };